module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/_iter-step.js
// module id = 568
// module chunks = 168707334958949